$(document)
  .on('click', '.occupancy-desc-box .fa-chevron-up', function() {

    $('.occupancy-desc-box .fa-chevron-up').toggleClass('collapsed')
    $('#packageForm .packages_wrapper').toggleClass('collapsed')

  })
